import axios from 'axios'
import FormData from 'form-data'
// import { compileToFunctions } from 'vue-template-compiler'
import ContactService from '../../../services/contact.js'
import { success, error } from '../../../utils/toastr.js'
import i18n from '../../../locales/i18n.js'

export default {
  async saveInfoContact({ commit }, params) {
    commit('SET_DATA_CONTACT', params)
  },
  // eslint-disable-next-line no-unused-vars
  async postInfoContact({ commit }, params) {
    try {
      await ContactService.store(params)
      success(i18n.t('msg.send_success'))
      commit('DEL_DATA_CONTACT', params)
    } catch (e) {
      error(i18n.t('msg.some_thing_went_wrong'))
    }
  },
  sendContactDetail() {
    const data = new FormData()
    data.append('your-subject', 'test')
    data.append('company', 'test')
    data.append('your-name', 'test')
    data.append('your-email', 'test@test.com')
    data.append('menu-title', 'hoge')
    data.append('your-message', 'fuga')
    const config = {
      method: 'post',
      url: 'https://stg.zatsudan-work.net/zatsudan_adminconsole/wp-json/contact-form-7/v1/contact-forms/5/feedback',
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Basic emF0c3VkYW4tc3RnLWJhc2ljYXV0aDpFZm45cVNCOURUMUhXOUluRmMzcw==',
        // ...data.getHeaders()
      },
      data
    }
    axios(config)
    .then((response) => {
      //console.log(JSON.stringify(response.data))
    })
    .catch((e) => {
      //console.log(e)
    })
  },
  app_user({ commit }, params) {
    commit('APP_USE', params)
  }
}
